import './index.css'
import ambitionplus from '../../assets/shapes_svg/ambition/ambitionplus.svg'
import linebreak from '../../assets/shapes_svg/roledetail/linebreak.svg'
import linebreak2 from '../../assets/shapes_svg/roledetail/linebreak2.svg'
import edit from '../../assets/shapes_svg/roledetail/edit.svg'
import { useState } from 'react'
import { Back2 } from '../../components/Option/Back'
import Add from '../../components/Option/Add'
import Delete from '../../components/Option/Delete'
import '../Ambition/index.css'
import '../AmbitionDetail/index.css'
import { ContainerBody } from '../../App'
const RoleAmbition = () => {
    window.scrollTo(0, 0);

    const [chosen,setChosen] = useState(0)
    const [department,setDepartment] = useState({
        "title" : "Organisation",
        "ambitions":["Quarterly Sustainable Goals", "Inter-department social networking"]
    })
    return ( 
        <ContainerBody className="ambition__body">
            <div className="ambitiondetail__wrapper2" style={{width:"100%",display:"flex",justifyContent:"flex-end",marginTop:"20px",height:"0"}}>
                <Back2 header={"Back to Ambition Page"} style={{marginRight:"auto",position:"relative",left:"-7%"}} to={"/ambition"}/>
                <div className="ambitiondetail__option" style={{position:"absolute",marginRight:"20px"}}>
                    <Delete header={"Delete Role's Ambition"}/>
                </div>
            </div>
            
            <div className="ambition__role__role">
                <div className="ambition__role__item">
                    <h4>{department.title}</h4>
                    
                </div>
                {department.ambitions.map((ambition,i) => {
                    return <div className={"ambition__role__ambition " + (chosen == i ? "__chosen__" : null)} onClick={() => setChosen(i)}>
                        <h4>{ambition}</h4>
                    </div>
                })}
                <div className="ambition__role__ambition__add">
                    <img src={ambitionplus} alt="" />
                    <h4>Add Ambition</h4>
                </div>
            </div>
            <img className="roleambition__linebreak" src={linebreak} alt="" />
            <div className="roleambition__body">
                <div className="roleambition__row">
                    <div className="roleambition__title">
                        Ambition
                    </div>
                    
                    
                        <div className="roleambition__bubble">
                        
                            <h4 className="roleambition__bubble__title">{department && department.ambitions[chosen]}<img src={linebreak2} alt="" /></h4>
                            
                            <h4 className="roleambition__bubble__subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus facere corporis, numquam sint ad quod vitae! Nobis quo tempora quos, et iusto, assumenda, iste nisi obcaecati saepe sunt autem quia.</h4>
                        </div>
                        <img className="roleambition__edit" src={edit} alt="" />
                    
                    

                </div>
                <div className="roleambition__row">
                    <div className="roleambition__title">
                        Success Criteria
                    </div>
                    <div className="roleambition__bubble bubble__style2" >
                        
                        <h4 className="roleambition__bubble__title title__style2">Minimum of all new sales are return customers</h4>
                        <h4 className="roleambition__bubble__title title__style2 bubble__add__style2" style={{cursor: "pointer"}}>
                            <img src={ambitionplus} alt="" />
                        </h4>
                        {/* <h4 className="roleambition__bubble__subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus facere corporis, numquam sint ad quod vitae! Nobis quo tempora quos, et iusto, assumenda, iste nisi obcaecati saepe sunt autem quia.</h4> */}
                    </div>

                </div>
                <div className="roleambition__row">
                    <div className="roleambition__title">
                        Responsibility
                    </div>
                    <div className="roleambition__bubble bubble__style2" >
                        <div className="roleambition__bubble__row">
                            <h4 className="roleambition__bubble__title title__style3">Joseph</h4>
                            <h4 className="roleambition__bubble__title title__style3">Sales</h4>
                        </div>
                        <div className="roleambition__bubble__row">
                            <h4 className="roleambition__bubble__title title__style3 bubble__add__style3">
                                <img src={ambitionplus} alt="" />Add Person
                            </h4>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="ambitiondetail__wrapper">
                <div className="ambitiondetail__option">
                    <Delete header={"Delete Role's Ambition"}/>
                    <Add header={"Add Ambition page to Report"}/>
                </div>
            </div>
        
        </ContainerBody>
    );
}
 
export default RoleAmbition;